import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['submit']

  declare readonly submitTargets: HTMLInputElement[]

  enable (): void {
    this.submitTargets.forEach(target => {
      target.disabled = false
    })
  }

  toggle ({ target }: Event): void {
    const input = target as HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement | null
    if (input == null || !input.required) return

    const value = input?.value ?? ''
    const enabled = value.trim().length > 0

    this.submitTargets.forEach(submitTarget => {
      submitTarget.disabled = !enabled
    })
  }
}
